import Schema from '../Schema';

/*
Labels
*/
const Labels = new Schema({
  _id: String,

  // ラベル名
  name: {
    type: String,
    default: ''
  },

  type: {
    type: String,
    default: ''
  },

  // フォローしているかどうか
  is_following: {
    type: Boolean,
    default: false
  }
});

export default Labels;
